// VISOS theme JS — reveal, ticker, cart AJAX
(function(){
  // reveal on scroll
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('on'); io.unobserve(e.target);} });
  },{threshold:.12});
  document.querySelectorAll('.v-rv').forEach(function(el){ io.observe(el); });

  // ── carrito AJAX de Shopify ──
  var fmt = function(cents){ return '$' + (cents/100).toLocaleString('es-CO'); };
  function updateBadge(cart){
    document.querySelectorAll('.v-cartbtn .n').forEach(function(el){ el.textContent = cart.item_count; });
  }
  function fetchCart(){ return fetch('/cart.js').then(function(r){ return r.json(); }); }
  var ov = document.getElementById('vCartOv'), dr = document.getElementById('vCartDr');
  function openCart(){ render(); ov.style.opacity=1; ov.style.pointerEvents='auto'; dr.style.transform='none'; }
  function closeCart(){ ov.style.opacity=0; ov.style.pointerEvents='none'; dr.style.transform='translateX(105%)'; }
  window.visosOpenCart = openCart;
  if (ov) ov.onclick = closeCart;
  var x = document.getElementById('vCartX'); if (x) x.onclick = closeCart;
  document.querySelectorAll('.v-cartbtn').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); openCart(); }); });

  function esc(s){ return String(s).replace(/[<>"&]/g, function(c){ return {'<':'&lt;','>':'&gt;','"':'&quot;','&':'&amp;'}[c]; }); }

  // imagen de la línea: la del dije si viene, si no la del producto
  function lineImg(i){
    var p = i.properties || {};
    if (p._img) return p._img;
    return i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/, '_200x$1$2') : '';
  }
  // título: si es un collar armado, muestra el dije
  function lineTitle(i){
    var p = i.properties || {};
    if (p['Dije']) return 'Collar ' + p['Dije'];
    return i.product_title;
  }
  // detalles visibles (todo lo que no empiece por guion bajo)
  function lineProps(i){
    var p = i.properties || {}, out = '';
    Object.keys(p).forEach(function(k){
      if (k.charAt(0) === '_' || !p[k]) return;
      out += '<div style="font-size:11.5px;color:var(--ink60);margin-top:1px">' + esc(k) + ': <b style="font-weight:600;color:var(--ink)">' + esc(p[k]) + '</b></div>';
    });
    return out;
  }

  function render(){
    fetchCart().then(function(cart){
      updateBadge(cart);
      var body = document.getElementById('vCartBody');
      var foot = document.getElementById('vCartFoot');
      if (!cart.items.length){
        body.innerHTML = '<div style="text-align:center;padding:60px 10px;color:var(--ink35)"><div style="font-family:\'Fraunces\',serif;font-style:italic;font-size:22px;color:var(--ink)">Tu carrito está vacío</div><p style="font-size:13px;margin-top:10px;font-weight:300">Los antojos no se piensan tanto.</p></div>';
        foot.innerHTML = '';
        return;
      }
      body.innerHTML = cart.items.map(function(i, idx){
        var src = lineImg(i);
        var img = src
          ? '<img src="' + src + '" style="object-fit:contain;background:var(--paper)">'
          : '<div style="width:74px;height:88px;border-radius:12px;background:var(--paper);flex:none"></div>';
        return '<div class="v-ci">' + img +
          '<div style="flex:1"><div style="font-family:\'Fraunces\',serif;font-weight:600;font-size:17px">' + esc(lineTitle(i)) + '</div>' +
          lineProps(i) +
          '<div style="font-size:13px;color:var(--ink35);margin-top:4px">' + fmt(i.final_line_price) + '</div>' +
          '<div style="display:flex;align-items:center;gap:10px;margin-top:8px">' +
          '<button class="qb" data-l="' + (idx+1) + '" data-q="' + (i.quantity-1) + '">−</button>' +
          '<b style="font-size:13px">' + i.quantity + '</b>' +
          '<button class="qb" data-l="' + (idx+1) + '" data-q="' + (i.quantity+1) + '">+</button>' +
          '<button class="rm" data-l="' + (idx+1) + '" style="border:none;background:none;font-size:11px;color:var(--cereza);cursor:pointer;margin-left:auto;text-decoration:underline">Quitar</button>' +
          '</div></div></div>';
      }).join('');
      foot.innerHTML =
        '<div style="display:flex;justify-content:space-between;margin-bottom:6px"><span style="font-size:13px;color:var(--ink35)">Subtotal</span><b style="font-family:\'Fraunces\',serif;font-size:19px">' + fmt(cart.total_price) + '</b></div>' +
        '<div style="display:flex;align-items:center;gap:8px;font-size:11px;font-weight:600;color:var(--sprite);margin-bottom:14px"><span style="width:8px;height:8px;border-radius:50%;background:var(--sprite)"></span>Domicilio gratis incluido</div>' +
        '<a href="/checkout" style="display:block;text-align:center;width:100%;background:var(--cereza);color:#fff;border-radius:100px;padding:17px;font-size:12px;font-weight:700;letter-spacing:.14em;text-transform:uppercase">Finalizar compra →</a>' +
        '<a href="/cart" style="display:block;text-align:center;font-size:11px;color:var(--ink35);margin-top:12px;text-decoration:underline">Ver carrito completo</a>';
      body.querySelectorAll('.qb').forEach(function(b){
        b.onclick = function(){ changeLine(+b.dataset.l, +b.dataset.q); };
      });
      body.querySelectorAll('.rm').forEach(function(b){
        b.onclick = function(){ changeLine(+b.dataset.l, 0); };
      });
    });
  }
  function changeLine(line, qty){
    fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({line:line, quantity:qty})})
      .then(function(r){ return r.json(); }).then(function(){ render(); });
  }
  window.visosAddToCart = function(variantId, qty, btn){
    fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id:variantId, quantity:qty||1})})
      .then(function(r){ if(!r.ok) throw new Error('err'); return r.json(); })
      .then(function(){
        if (btn){ var t = btn.textContent; btn.textContent = '✓'; setTimeout(function(){ btn.textContent = t; }, 900); }
        openCart();
      })
      .catch(function(){ if(btn){ btn.textContent = 'Agotado'; } });
  };
  // quick add buttons
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-vadd]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    window.visosAddToCart(+b.dataset.vadd, 1, b);
  });
  fetchCart().then(updateBadge);
})();
